import script from "./FooterTwa.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterTwa.vue?vue&type=script&setup=true&lang=js"

import "./FooterTwa.vue?vue&type=style&index=0&id=0b6a9263&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6a9263"]])

export default __exports__